<template>
  <div class="all">
    <Header></Header>
    <div class="contents">
      <div class="top-message">
        <h1>商品ページ</h1>
      </div>
      <div class="information">
        <img :src="selectedItem.img_url" />
        <table>
          <tbody>
            <tr>
              <th colspan="2" class="Iteminfo_title">商品情報</th>
            </tr>
            <tr>
              <th>出品者</th>
              <td>{{ selectedItem.seller }}</td>
            </tr>
            <tr>
              <th>商品名</th>
              <td>{{ selectedItem.item }}</td>
            </tr>
            <tr>
              <th>商品説明</th>
              <td><nl2br tag="div" :text="selectedItem.description" /></td>
            </tr>
            <tr>
              <th>商品の状態</th>
              <td>{{ selectedItem.condition }}</td>
            </tr>
            <tr>
              <th>価格</th>
              <td>{{ selectedItem.price }}円</td>
            </tr>
          </tbody>
        </table>
        <!-- 商品が売り切れて、かつ出品ユーザIdとログイン中のユーザIDが等しければ、取引画面へ -->
        <div
          v-if="!selectedItem.isSold && this.user.uid == selectedItem.userID"
        >
          <p class="purchased" style="color: red; font-size: 20px">
            商品が購入されました！取引画面へ進んで、購入者と取引日時や場所を決めてください。
          </p>
          <button class="btn edit" @click="goTrade">取引画面へ</button>
        </div>
        <!-- 売り切れ中なら売り切れと表示 -->
        <div v-else-if="!selectedItem.isSold">
          <button class="btn soldOut" style="pointer-events: none">
            売り切れ
          </button>
        </div>
        <!-- ログイン中のuidと、商品のuserIDが一致(出品者と、閲覧者が同一の時)、編集するボタンを表示 -->
        <div v-else-if="this.user.uid == selectedItem.userID">
          <router-link
            :to="{ name: 'editItem', params: { id: this.selectedItem.itemID } }"
          >
            <button class="btn edit" @click="editItem()">編集する</button>
          </router-link>
        </div>
        <!-- それ以外なら、購入するボタンを表示する -->
        <div v-else>
          <button class="btn buy" @click="purchase()">購入する</button><br />
          <!-- <button class="btn like" @click="like()">いいね</button>    -->
        </div>
      </div>
      <hr />
      <div class="chatArea">
        <h3>コメント</h3>
        <p>気になることがあれば出品者に質問してみましょう。</p>
        <!-- Chatコンポーネントに表示中のitemIDと、ログイン中のユーザオブジェクトと、出品者IDを渡している -->
        <Chat
          v-bind:itemID="this.selectedItem.itemID"
          v-bind:user="this.user"
          v-bind:userID="this.selectedItem.userID"
          v-bind:item="this.selectedItem.item"
          v-bind:isSold="this.selectedItem.isSold"
        ></Chat>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import db from "../plugins/firestore";
import firebase from "firebase";
import Chat from "./Chat.vue";
// 改行を <br> タグに変換するモジュール
import Nl2br from "vue-nl2br";

export default {
  components: { Header, Chat, Nl2br },
  data() {
    return {
      //マイページ、検索結果画面で選択された商品情報を、vuexから取ってくる。
      //入っている情報は、商品情報（価格とかタイトル）＋ドキュメントID
      selectedItem: this.$store.getters.selectedItem,
      user: "", //ログイン中のユーザー
    };
  },
  //未ログインなら、ランディングページに飛ばす。ログイン済なら、userにログイン中のユーザオブジェクトを格納.
  //そして、selectedItemIDをgetInformation関数に渡す。そうすると、itemIDをもとにfirestoreから情報を取ってくる。
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        this.$router.push({ path: "/" });
      } else {
        this.user = user;
        //this.getItemInformation(this.selectedItemID) //商品情報をfirestoreから取得するmethods
      }
    });
  },
  methods: {
    //編集するボタンが押されたら、vuexにitemInformationを突っ込んで、編集ページ(Edit.vue)に飛ばす。
    editItem() {
      this.$store.dispatch("edit", this.selectedItem);
    },
    //「購入する」ボタンが押されたら、ドキュメントを追加。
    purchase() {
      const result = confirm("購入しますか？");
      if (result) {
        //商品を売り切れに更新
        const docRef = db.collection("textbooks").doc(this.selectedItem.itemID);
        docRef.update({
          isSold: false,
        });
        //vuexにslectedItemID,購入者情報を管理
        //まず、ユーザ情報を取得
        // db.collection("users").doc(this.user.uid).get().then((doc)=>{

        // })
        // const buyer = this.user.displayName
        // this.selectedItem.buyer = buyer
        this.$store.dispatch("purchasedItem", this.selectedItem.itemID);
        //users=>doc=>purchasesに購入した商品を追加
        db.collection("users")
          .doc(this.user.uid)
          .collection("purchases")
          .doc(this.selectedItem.itemID)
          .set({
            itemID: this.selectedItem.itemID,
          })
          .then(() => {
            //購入したら、vuexに商品情報をストアして取引画面に飛ばす。取引画面に飛ばす
            db.collection("users")
              .doc(this.selectedItem.userID)
              .collection("information")
              .doc(this.selectedItem.itemID)
              .set({
                information:
                  "出品中の「" +
                  this.selectedItem.item +
                  "」" +
                  "が購入されました。マイページ→出品した商品→商品ページ→取引画面から取引を開始してください",
                isRead: false, //読まれたかどうか
                timestamp: firebase.firestore.FieldValue.serverTimestamp(), //購入された日時
              });
            this.$store.dispatch("goTrade", this.selectedItem);
            this.$router.push({ path: "/trade" });
          })
          .catch(() => {
            console.error("エラーにより購入できませんでした。");
          });
      }
    },
    //取引画面へボタンが押されたら、vuexに商品情報をストアして、取引画面に飛ばす
    goTrade() {
      this.$store.dispatch("goTrade", this.selectedItem);
      this.$router.push({ path: "/trade" });
    },
    handleClick() {
      // console.log(this.$refs.ThumbsUp.$data);
      //do something
    },
    like() {
      db.collection("users")
        .doc(this.user.uid)
        .collection("likes")
        .doc(this.selectedItem.itemID)
        .set({
          like: this.selectedItem.itemID,
        });
    },
  },
};
</script>


<style scoped>
.all {
  background-color: rgba(166, 173, 179, 0.158);
}

.information img {
  width: 20%;
}

.contents {
  text-align: center;
}

.information {
  padding-top: 20px;
}

.buy:hover {
  background-color: rgba(255, 0, 0, 1);
}

.buy {
  background-color: rgba(255, 0, 0, 0.9);
}

.edit {
  margin: 20px;
  background-color: rgba(53, 174, 243, 0.9);
}

.edit:hover {
  background-color: rgba(53, 174, 243, 1);
}

.soldOut {
  background-color: rgb(200, 200, 200);
}

.like {
  margin-top: 0px;
  background-color: rgb(200, 200, 200);
}

table {
  margin: 0 auto;
  border-collapse: collapse; /* セルの線を重ねる */
  width: 30%;
  border-color: rgb(220, 220, 220);
  margin-top: 5%;
}

th {
  background-color: rgb(250, 250, 250);
  width: 25%;
}

th,
td {
  padding: 5px 10px; /* 余白指定 */
}

td {
  background-color: rgb(250, 250, 250);
}

.chatArea p {
  padding-bottom: 15px;
}

.Iteminfo_title{
    text-align: left;
    color:rgb(28, 125, 97);
    background-color: rgba(255, 252, 247, 0.534);
}


@media all and (max-width: 670px) {
  .information img {
    width: 90%;
  }

  table {
    width: 90%;
  }

  th {
    width: 25%;
    font-size: 12px;
  }

  td {
    font-size: 13px;
  }
}
</style>